"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var cssProperties_1 = require("../constants/cssProperties");

var directionalPropsToStylesUtil = function directionalPropsToStylesUtil(props, propToStyleMap, styleSystem, stylePostfix) {
  var styles = {};
  Object.keys(propToStyleMap).forEach(function (prop) {
    var rawValue = props[prop];
    var value = '';

    if (styleSystem[rawValue]) {
      value = styleSystem[rawValue] + "px";
      value = stylePostfix ? value + " " + stylePostfix : value;
    } else if (cssProperties_1.globalCssProperties.indexOf(rawValue) >= 0) {
      value = rawValue;
    }

    if (value) {
      if (Array.isArray(propToStyleMap[prop])) {
        propToStyleMap[prop].forEach(function (style) {
          styles[style] = value;
        });
      } else {
        var style = propToStyleMap[prop];
        styles[style] = value;
      }
    }
  });
  return styles;
};

exports.default = directionalPropsToStylesUtil;